import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Injectable } from "@angular/core";
import * as moment from 'moment-mini';

@Injectable()
export class TrainingFunctions {

  colorDate(columnValue: Date, interval: number): SafeStyle {
    let dateValue = new Date(columnValue);
    let today = new Date();
    let result = 'tranparent';
    let todayPlus30 = this.addDays(new Date(), 30);
    let todayPlus60 = this.addDays(new Date(), 60);
    let todayPlus90 = this.addDays(new Date(), 90);

    if (dateValue == undefined || interval == 0) {
      result = 'tranparent';
    }
    else {
      let retakeByDate = this.addMonths(dateValue, interval);

      if (retakeByDate <= today) {
        result = 'red';
      }
      else if (retakeByDate <= todayPlus30) {
        result = 'orange';
      }
      else if (retakeByDate <= todayPlus60) {
        result = 'blue';
      }
      else if (retakeByDate <= todayPlus90) {
        result = 'green';
      }
    }

    let ret = {};
    ret['color'] = result;
    return ret;
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  addMonths(date: Date, months: number): Date {
    date.setMonth(date.getMonth() + months);
    return date;
  }

  canUpdateTraining(training: any): boolean {

    if (training.qtActive && training.qtRequired) {
      if (training.qtHistory != null) {

        let today = new Date();
        let completedOnValue = new Date(training.qtHistory.completedOn);

        if (training.qtHistory.revoked || (training.intervalInMonths > 0 && completedOnValue < today)) {
          return true;
        }
        else if (training.qtHistory.certifiedBy == null) {
          return false;
        }
        else {
          return false;
        }
      }
      else {
        return true;
      }
    }
    else {
      return false;
    }
  }

}
